import { render, staticRenderFns } from "./DialogEditNetwork.vue?vue&type=template&id=54289e9b&scoped=true"
import script from "./DialogEditNetwork.js?vue&type=script&lang=js&external"
export * from "./DialogEditNetwork.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54289e9b",
  null
  
)

export default component.exports